module.exports = __webpack_public_path__ + "img/hy_icon1.742f6df1.png";